import { selector } from 'recoil';
// eslint-disable-next-line import/extensions
import accessTokenAtom from '../user/accessTokenAtom';
import { parseAccessToken } from '../../components/helpers/Util';

/**
 * Contains info derived from a user access token
 */
export default selector({
  key: 'accessInfoSelector',
  get: ({ get }) => {
    const accessToken = get(accessTokenAtom);
    if (!accessToken) {
      return {
        network: 'meetme', // default network?
      };
    }
    const info = parseAccessToken(accessToken);
    return {
      network: 'meetme', // default network?
      ...info,
    };
  },
});
